<template>
    <DForm @submit.prevent="submitForm">
        <div
            v-for="(translation, key) in translations"
            :key="key"
        >
            <DCard
                padding
                :title="defaultLanguageLabel(translation)"
                class="mb-3"
            >
                <DFormRow
                    :label="__('settings.tax_rules.form.invoice_text')"
                    :hint="__('settings.tax_rules.form.invoice_text_hint')"
                >
                    <DFormTextarea
                        id="invoice_text"
                        v-model="form.translations[key].invoice_text.value"
                        :is-valid="isFormFieldValid('invoice_text')"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('settings.tax_rules.form.invoice_text_with_vat')"
                    :hint="__('settings.tax_rules.form.invoice_text_with_vat_hint')"
                >
                    <DFormTextarea
                        id="invoice_text_with_vat"
                        v-model="form.translations[key].invoice_text_with_vat.value"
                        :is-valid="isFormFieldValid('invoice_text_with_vat')"
                    />
                </DFormRow>
            </DCard>
        </div>
        <DFormControls
            :cancel-route="$route('settings.tax-rules.index')"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'
import { __ } from '~@/Composables/translation'

const props = defineProps({
    taxRule: {
        type: Object,
        default: () => {
            return {}
        }
    },
    translations: {
        type: Object,
        default: () => {
            return {}
        }
    },
    defaultTenantLanguage: {
        type: String,
        default: ''
    }
})

const form = useForm({
    translations: props.translations
})

const submitForm = () => {
    form.post(route('settings.tax-rules.translations-update', { taxRule: props.taxRule.id ?? 0 }))
}

const defaultLanguageLabel = (translation) => props.defaultTenantLanguage.value === translation.language.value ? `${__('settings.default_customer_language')} ${translation.language.label}` : translation.language.label

</script>

<style scoped lang="scss">

</style>
